import ApiService from "@/service/ApiService";

export default function useLogin() {
  const CheckUser = async (id) => {
    ApiService.setHeader();
    return await ApiService.query("query/check_query_communitys/" + id);
  };

  return {
    CheckUser,
  };
}
